import { render, staticRenderFns } from "./block-background.vue?vue&type=template&id=101ebae2&"
import script from "./block-background.vue?vue&type=script&lang=js&"
export * from "./block-background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports